const datosDeudaEmpresa = {
   datos: null,
   loading: true,
   exportandoExcelDeudaEmpresa: false,
   internalerror: {internalerror:false,msg:null},
};

export default datosDeudaEmpresa;
